var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"mondays-view-frame",attrs:{"src":"https://forms.monday.com/forms/embed/873a735113fd377dceac2fb66475daa5?r=use1"}})}
var staticRenderFns = []

export { render, staticRenderFns }